/* eslint-disable max-lines-per-function, max-statements, complexity, max-lines */
/**
 * Default values for reviews state
 */
const DEFAULT_LIST = [];
const DEFAULT_IS_ADD_HOME_VIDEO = true;
const DEFAULT_IS_ALL_AROUND_GATHER = false;
const DEFAULT_IS_MATCH_TITLE = false;
const DEFAULT_IS_ONLY_NEW = true;
const DEFAULT_IS_ONLY_PRESENT = false;
const DEFAULT_IS_SHOW_FLAGGED = false;
const DEFAULT_IS_TOGGLE_FLAGGED_LOADING = false;
const DEFAULT_IS_UHD = true;
const DEFAULT_NEXT_CURSOR = null;
/**
 * DEFAULT_SELECTED
 *
 * Selected Review
 */
const DEFAULT_SELECTED = {
    id: "",
    isCreated: false,
    isPreviewLoading: false,
    isPreviewValid: false,
    review: {},
    url: ""
};
/**
 * DEFAULT_HOME_VIDEO_REVIEW
 *
 * Default Home Video Review to create
 */
export const DEFAULT_HOME_VIDEO_REVIEW = {
    isAddHomeVideo: DEFAULT_IS_ADD_HOME_VIDEO,
    isBluRay: true,
    isPublished: false,
    isUHD: DEFAULT_IS_UHD,
    screenshots: []
};
/**
 * initalReviewsState
 *
 * Initial state for each review service
 */
const initalReviewsState = {
    display: DEFAULT_LIST,
    isAllAroundGather: DEFAULT_IS_ALL_AROUND_GATHER,
    isOnlyNew: DEFAULT_IS_ONLY_NEW,
    isOnlyPresent: DEFAULT_IS_ONLY_PRESENT,
    isShowFlagged: DEFAULT_IS_SHOW_FLAGGED,
    nextCursor: DEFAULT_NEXT_CURSOR,
    selected: DEFAULT_SELECTED
};
/**
 * initialState
 *
 * Initial state for all reviews
 */
export const initialState = {
    avForums: initalReviewsState,
    avNirvana: initalReviewsState,
    avsForum: initalReviewsState,
    bluRay: initalReviewsState,
    bluRayAuthority: initalReviewsState,
    digitalBits: initalReviewsState,
    doBlu: initalReviewsState,
    hidefDigest: initalReviewsState,
    highDefDiscNews: initalReviewsState,
    homeTheaterForum: initalReviewsState,
    homeVideoReview: DEFAULT_HOME_VIDEO_REVIEW,
    isMatchTitle: DEFAULT_IS_MATCH_TITLE,
    isToggleFlaggedLoading: DEFAULT_IS_TOGGLE_FLAGGED_LOADING,
    isUHD: DEFAULT_IS_UHD,
    theaterByte: initalReviewsState,
    whySoBlu: initalReviewsState
};
/**
 *  Action Types
 */
export const RESET_SELECTED_REVIEW = "RESET_SELECTED_REVIEW";
export const RESET_SELECTED_REVIEWS = "RESET_SELECTED_REVIEWS";
export const SET_HOME_VIDEO_ID = "SET_HOME_VIDEO_ID";
export const SET_IS_ADD_HOME_VIDEO = "SET_IS_ADD_HOME_VIDEO";
export const SET_IMAGES = "SET_IMAGES";
export const SET_IS_ALL_AROUND_GATHER = "SET_IS_ALL_AROUND_GATHER";
export const SET_IS_MATCH_TITLE = "SET_IS_MATCH_TITLE";
export const SET_IS_ONLY_NEW = "SET_IS_ONLY_NEW";
export const SET_IS_ONLY_PRESENT = "SET_IS_ONLY_PRESENT";
export const SET_IS_SHOW_FLAGGED = "SET_IS_SHOW_FLAGGED";
export const SET_IS_TOGGLE_FLAGGED_LOADING = "SET_IS_TOGGLE_FLAGGED_LOADING";
export const SET_IS_UHD = "SET_IS_UHD";
export const SET_LIST = "SET_LIST";
export const SET_NAME = "SET_NAME";
export const SET_NEXT_CURSOR = "SET_NEXT_CURSOR";
export const SET_IMDB_ID = "SET_IMDB_ID";
export const SET_TMDB_SELECTED_IMDB_ID = "SET_TMDB_SELECTED_IMDB_ID";
export const SET_TMDB_SELECTED_ID = "SET_TMDB_SELECTED_ID";
export const SET_REVIEW = "SET_REVIEW";
export const SET_SELECTED_ID = "SET_SELECTED_ID";
export const SET_SELECTED_IS_PREVIEW_LOADING = "SET_SELECTED_IS_PREVIEW_LOADING";
export const SET_SELECTED_IS_PREVIEW_VALID = "SET_SELECTED_IS_PREVIEW_VALID";
export const SET_SELECTED_IS_REVIEW_CREATED = "SET_SELECTED_IS_REVIEW_CREATED";
export const SET_SELECTED_HOME_VIDEO_REVIEW = "SET_SELECTED_HOME_VIDEO_REVIEW";
export const SET_TECH_SPECS = "SET_TECH_SPECS";
export const SET_SCREENSHOTS = "SET_SCREENSHOTS";
/**
 * parseTitle
 *
 * @description Parse title to remove year, 4K, and 3D
 * @param {string} title - Title to parse
 * @returns {string} - Parsed title
 *
 */
const parseTitle = (title) => title
    // Remove year in parentheses
    .replace(/\(\d+\)$/u, "")
    .trim()
    // Remove 4K + 3D
    .replace(/4K \+ 3D/u, "")
    .trim()
    // Remove 4K
    .replace(/4K$/u, "")
    .trim()
    // Remove 3D
    .replace(/3D$/u, "")
    .trim();
/**
 * getSelectedTitleAndUrl
 *
 * @description Get selected title and url from state
 * @param {ReviewsState} state - Current state of all reviews
 * @param {string} selected - Selected review id
 * @returns {{ title: string; url: string }} - Object containing title and url
 *
 */
const getSelectedTitleAndUrl = (state, selected) => {
    const result = state.display.find(({ id }) => id === selected);
    if (!result) {
        return { title: "", url: "" };
    }
    return {
        title: parseTitle(result.title),
        url: result.url
    };
};
/**
 * reducer
 *
 *  @description Reducer for all reviews
 *  @param {AllReviewsState} state - Current state of all reviews
 *  @param {ReviewsAction} action - Action to be performed
 *  @returns {AllReviewsState} - New state of all reviews
 *
 */
const reducer = (
// eslint-disable-next-line default-param-last
state = initialState, action) => {
    switch (action.type) {
        case RESET_SELECTED_REVIEW: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    selected: DEFAULT_SELECTED
                }
            };
        }
        case RESET_SELECTED_REVIEWS: {
            return {
                avForums: { ...state.avForums, selected: DEFAULT_SELECTED },
                avNirvana: { ...state.avNirvana, selected: DEFAULT_SELECTED },
                avsForum: { ...state.avsForum, selected: DEFAULT_SELECTED },
                bluRay: { ...state.bluRay, selected: DEFAULT_SELECTED },
                bluRayAuthority: {
                    ...state.bluRayAuthority,
                    selected: DEFAULT_SELECTED
                },
                digitalBits: { ...state.digitalBits, selected: DEFAULT_SELECTED },
                doBlu: { ...state.doBlu, selected: DEFAULT_SELECTED },
                hidefDigest: { ...state.hidefDigest, selected: DEFAULT_SELECTED },
                highDefDiscNews: {
                    ...state.highDefDiscNews,
                    selected: DEFAULT_SELECTED
                },
                homeTheaterForum: {
                    ...state.homeTheaterForum,
                    selected: DEFAULT_SELECTED
                },
                homeVideoReview: { ...DEFAULT_HOME_VIDEO_REVIEW, isUHD: state.isUHD },
                isMatchTitle: state.isMatchTitle,
                isToggleFlaggedLoading: state.isToggleFlaggedLoading,
                isUHD: state.isUHD,
                tmdbSelectedImdbId: undefined,
                tmdbSelectedId: undefined,
                theaterByte: {
                    ...state.theaterByte,
                    selected: DEFAULT_SELECTED
                },
                whySoBlu: { ...state.whySoBlu, selected: DEFAULT_SELECTED }
            };
        }
        case SET_HOME_VIDEO_ID: {
            return {
                ...state,
                homeVideoReview: {
                    ...state.homeVideoReview,
                    homeVideoId: action.payload.homeVideoId
                }
            };
        }
        case SET_IMAGES: {
            return {
                ...state,
                homeVideoReview: {
                    ...state.homeVideoReview,
                    images: action.payload.images
                }
            };
        }
        case SET_SCREENSHOTS: {
            return {
                ...state,
                homeVideoReview: {
                    ...state.homeVideoReview,
                    screenshots: action.payload.screenshots
                }
            };
        }
        case SET_IS_ADD_HOME_VIDEO: {
            return {
                ...state,
                homeVideoReview: {
                    ...state.homeVideoReview,
                    isAddHomeVideo: action.payload.isAddHomeVideo
                }
            };
        }
        case SET_IS_ALL_AROUND_GATHER: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    isAllAroundGather: action.payload.isAllAroundGather
                }
            };
        }
        case SET_IS_MATCH_TITLE: {
            return {
                ...state,
                isMatchTitle: action.payload.isMatchTitle
            };
        }
        case SET_IS_ONLY_NEW: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    isOnlyNew: action.payload.isOnlyNew,
                    isOnlyPresent: action.payload.isOnlyNew
                        ? false
                        : state[action.payload.service].isOnlyPresent
                }
            };
        }
        case SET_IS_ONLY_PRESENT: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    isOnlyNew: action.payload.isOnlyPresent
                        ? false
                        : state[action.payload.service].isOnlyNew,
                    isOnlyPresent: action.payload.isOnlyPresent
                }
            };
        }
        case SET_IS_SHOW_FLAGGED: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    isShowFlagged: action.payload.isShowFlagged
                }
            };
        }
        case SET_IS_TOGGLE_FLAGGED_LOADING: {
            return {
                ...state,
                isToggleFlaggedLoading: action.payload.isToggleFlaggedLoading
            };
        }
        case SET_IS_UHD: {
            return {
                ...initialState,
                homeVideoReview: {
                    ...initialState.homeVideoReview,
                    isUHD: action.payload.isUHD
                },
                isUHD: action.payload.isUHD
            };
        }
        case SET_LIST: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    display: action.payload.list
                }
            };
        }
        case SET_NAME: {
            return {
                ...state,
                homeVideoReview: {
                    ...state.homeVideoReview,
                    name: action.payload.name
                }
            };
        }
        case SET_NEXT_CURSOR: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    nextCursor: action.payload.nextCursor
                }
            };
        }
        case SET_IMDB_ID: {
            return {
                ...state,
                homeVideoReview: {
                    ...state.homeVideoReview,
                    IMDbId: action.payload.IMDbId
                }
            };
        }
        case SET_TMDB_SELECTED_IMDB_ID: {
            return {
                ...state,
                tmdbSelectedImdbId: action.payload.tmdbSelectedImdbId
            };
        }
        case SET_TMDB_SELECTED_ID: {
            return {
                ...state,
                tmdbSelectedId: action.payload.tmdbSelectedId
            };
        }
        case SET_REVIEW: {
            return {
                ...state,
                [`${action.payload.serviceName}`]: {
                    ...state[action.payload.serviceName],
                    selected: {
                        ...state[action.payload.serviceName].selected,
                        review: {
                            ...state[action.payload.serviceName].selected.review,
                            ...action.payload.review
                        }
                    }
                }
            };
        }
        case SET_SELECTED_ID: {
            const { title, url } = getSelectedTitleAndUrl(state[action.payload.service], action.payload.selected);
            return {
                ...state,
                homeVideoReview: {
                    ...state.homeVideoReview,
                    isUHD: state.isUHD,
                    // Always reset selected service id
                    [`${action.payload.service}Id`]: ""
                },
                isUHD: state.isUHD,
                matchTitle: title,
                // Add selected service to state
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    selected: {
                        ...state[action.payload.service].selected,
                        id: action.payload.selected,
                        isCreated: false,
                        isPreviewValid: false,
                        url
                    }
                }
            };
        }
        case SET_SELECTED_HOME_VIDEO_REVIEW: {
            return {
                ...state,
                homeVideoReview: {
                    ...state.homeVideoReview,
                    [`${action.payload.service}Id`]: action.payload.id,
                    isPublished: action.payload.isPublished
                },
                matchTitle: parseTitle(action.payload.title),
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    selected: {
                        ...state[action.payload.service].selected,
                        id: action.payload.id,
                        isCreated: action.payload.isCreated ?? false,
                        isPreviewValid: action.payload.isPreviewValid ?? false,
                        url: action.payload.url
                    }
                }
            };
        }
        case SET_SELECTED_IS_PREVIEW_LOADING: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    selected: {
                        ...state[action.payload.service].selected,
                        isPreviewLoading: action.payload.isPreviewLoading
                    }
                }
            };
        }
        case SET_SELECTED_IS_PREVIEW_VALID: {
            return {
                ...state,
                [`${action.payload.service}`]: {
                    ...state[action.payload.service],
                    selected: {
                        ...state[action.payload.service].selected,
                        isPreviewValid: action.payload.isPreviewValid
                    }
                }
            };
        }
        case SET_SELECTED_IS_REVIEW_CREATED: {
            return {
                ...state,
                homeVideoReview: {
                    ...state.homeVideoReview,
                    [`${action.payload.service}Id`]: action.payload.id
                }
            };
        }
        case SET_TECH_SPECS: {
            return {
                ...state,
                homeVideoReview: {
                    ...state.homeVideoReview,
                    techSpecs: action.payload.techSpecs
                }
            };
        }
        default: {
            return state;
        }
    }
};
export default reducer;
